'use strict';

angular.module('TurneroApp', [
    'ui.router',
    'ngResource',
    'ngStorage',
    'ngSanitize',
    'ngMaterial',
    'ui.select',
    'cl.paging',
    'angularGrid',
    'ngAria',
    'ngMessages',
    'ngAnimate',
    'angular.filter',
    'md.data.table',
    'ngLocale',
    'ngExcel',
    'ngCanvasGauge',
    'ngCookies',
    'as.sortable',
    'chart.js',
])

    .factory('$exceptionHandler', ['$log', function ($log) {
        return function myExceptionHandler(exception, cause) {
            if (localStorage["ngStorage-TurneroApp_Authorization"] || localStorage["ngStorage-TurneroApp_Authorization_Centro"]) {
                var auxData = {
                    Mensaje: exception.message ? exception.message : exception,
                    Objeto: window.location.href,
                    Backtrace: exception.stack
                }
                $.ajax({
                    url: 'api/General/Errores_Post/',
                    data: auxData,
                    method: 'POST',
                    beforeSend: function (xhr, settings) {
                        xhr.setRequestHeader('Authorization', localStorage["ngStorage-TurneroApp_Authorization"] ? ('Bearer ' + JSON.parse(localStorage["ngStorage-TurneroApp_Authorization"]).token) : ('Bearer ' + JSON.parse(localStorage["ngStorage-TurneroApp_Authorization_Centro"]).token));
                    }
                }).done(function () {
                    $log.warn(exception, cause);
                }).fail(function () {

                })
            }
        }
    }])


    /* Setup global settings */
    .service('settingsService', function () {
        this.layout = {
            pageSidebarClosed: true, // sidebar menu state
            pageContentWhite: true, // set page content layout
            pageBodySolid: false, // solid body color state
            pageAutoScrollOnLoad: 1000 // auto scroll to top on page load
        };
    })


    /* Init global settings and run the app */
    .run([
        '$rootScope',
        '$state',
        '$transitions',
        '$location',
        '$sessionStorage',
        'settingsService',
        'seguridadService',
        'TurneroAppConstant',
        'miDoctaModoService',
        function ($rootScope, $state, $transitions, $location, $sessionStorage, settingsService, seguridadService, TurneroAppConstant, miDoctaModoService) {
            $rootScope.$state = $state; // state to be accessed from view
            $rootScope.settings = settingsService; // settings to be accessed from view
            $rootScope.urlHostServer = $location.protocol() + '://' + $location.host() + '/';
            // El modo Mi Docta solo debe nacer desde el iframe o desde URLs internas que ya lo preservan.
            // Si la app carga en un link normal sin el query, limpiamos sessionStorage para no contaminar
            // ingresos comunes reutilizando la misma pestaña.
            try {
                var modoQ = $location.search()[TurneroAppConstant.integracionMiDocta.queryParamModoCliente];
                if (modoQ === '1' || modoQ === 'true' || modoQ === 'S' || modoQ === 's') {
                    miDoctaModoService.activar();
                } else if (modoQ === '0' || modoQ === 'false' || modoQ === 'N' || modoQ === 'n') {
                    miDoctaModoService.desactivar();
                } else if (($location.path() || '').indexOf('/integracion/mi-docta') !== 0) {
                    miDoctaModoService.desactivar();
                }
            } catch (eActivar) { }
            // Bandera global accesible desde plantillas (banner, header, etc).
            $rootScope.modoRestringidoClienteMiDocta = miDoctaModoService.estaActivo();
        function turneroEsModoClienteMiDocta() {
                return miDoctaModoService.estaActivo();
            }

        function turneroNombreEstadoPermitidoModoClienteMiDocta(nombreEstado) {
                if (!nombreEstado) return true;
                if (nombreEstado.indexOf('admin') === 0) return false;
                if (nombreEstado.indexOf('sidebar') === 0) return false;
                if (nombreEstado.indexOf('monitor') === 0) return false;
                if (nombreEstado.indexOf('llamador') === 0) return false;
                if (nombreEstado.indexOf('recepcion') === 0) return false;
                if (nombreEstado === 'login' || nombreEstado === 'home') return true;
                if (nombreEstado === 'cancelarturno' || nombreEstado.indexOf('cancelarturno') === 0) return true;
                if (nombreEstado === 'encuesta' || nombreEstado.indexOf('encuesta') === 0) return true;
                if (nombreEstado.indexOf('integracionMiDocta') === 0) return true;
                if (nombreEstado.indexOf('ciudadano.') === 0 || nombreEstado.indexOf('ciudadanoPortal.') === 0) {
                    var bloqueados = ['atenciontelefonica', 'tasas', 'tasashistorico'];
                    for (var i = 0; i < bloqueados.length; i++) {
                        if (nombreEstado === 'ciudadano.' + bloqueados[i] || nombreEstado === 'ciudadanoPortal.' + bloqueados[i]) {
                            return false;
                        }
                    }
                    return true;
                }
                return false;
            }

            $transitions.onStart({}, function (trans) {
                if (!turneroEsModoClienteMiDocta()) return;
                var to = trans.to();
                var nombre = to.name;
                if (turneroNombreEstadoPermitidoModoClienteMiDocta(nombre)) return;
                return trans.router.stateService.target('ciudadano.tramites', {}, { inherit: false, reload: true });
            });
            //Diego

            //$transitions.onStart({}, function (transition) {
            //    if ($rootScope.$$phase != '$digest') {
            //        $rootScope.$digest();
            //    }
            //});

            $transitions.onSuccess({}, function () {
                $('html').animate({ scrollTop: 0 })

                swal.close();
            })

            seguridadService.getUsuario().then(function (usuario) {
                $rootScope.usuario = usuario;
            }).catch(function (err) {
                console.info('no se pudo obtener el usuario: ');
            });
        }
    ])

    .config(['$httpProvider',
        '$mdDateLocaleProvider',
        '$mdThemingProvider',
        '$mdAriaProvider',
        '$locationProvider',
        function ($httpProvider, $mdDateLocaleProvider, $mdThemingProvider, $mdAriaProvider, $locationProvider) {
            console.log('moment.locale() previo: ' + moment.locale());
            //moment().locale('es'); //Esta sintaxis NO sirve para cambiar el locale
            moment.locale("es");
            console.log('moment.locale() nuevo: ' + moment.locale());
            //Manejador que se interponen entre las request y las response para autenticar la misma
            $httpProvider.interceptors.push('authInterceptorService');

            moment: {
                noGlobal: true
            }
            $mdAriaProvider.disableWarnings();


            $mdThemingProvider.definePalette('customPrimary', {
                '50': '#0563A7',
                '100': '#0563A7',
                '200': '#0563A7',
                '300': '#0563A7',
                '400': '#0563A7',
                '500': '#004b81', 
                '600': '#0563A7',
                '700': '#0563A7',
                '800': '#0563A7',
                '900': '#0563A7',
                'A100': '#0563A7',
                'A200': '#0563A7',
                'A400': '#0563A7',
                'A700': '#0563A7',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 300 400 A100',
                'contrastStrongLightColors': '500 600 700 A200 A400 A700'
              });

            $mdThemingProvider.theme('default')
                .primaryPalette('customPrimary')
                .accentPalette('customPrimary');

            $mdDateLocaleProvider.formatDate = function (date) {
                return moment(date).format('DD/MM/YYYY');
            };

            $mdDateLocaleProvider.parseDate = function (dateString) {
                var m = moment(dateString, 'DD/MM/YYYY', true);
                return m.isValid() ? m.toDate() : new Date(NaN);
            };
        }
    ])
    .filter('trustedhtml', [
        '$sce',
        function ($sce) {
            return $sce.trustAsHtml;
        }]
    );



// WEBPACK FOOTER //
// ./app/app.js